import React from 'react'

import NeedsSave from './NeedsSave'

export default function Flash({ onSaveAll, style }) {
  return <NeedsSave onSaveAll={onSaveAll} style={style} />
}
